import styled from 'styled-components';

import { FONTS } from '~/src/common/theme';
import { COLORS } from '~/src/common/theme';
import { media } from '~/src/common/theme/deprecated';

export const Container = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 252px;
  width: 100%;
  margin: 100px auto;

  ${media.M`
    max-width: 100%;
  `}

  & > h2, & > div {
    font-family: ${FONTS.RETHINK};
    text-transform: initial;
    color: ${COLORS.NEUTRAL_DEFAULT};
  }
`;

export const ErrorTitle = styled.h2`
  margin-bottom: 10px;

  text-transform: capitalize;
  font-size: 30px;
  font-weight: bold;
`;

export const ErrorCode = styled.div`
  display: flex;
  align-items: center;
  margin: 15px;
  font-size: 58px;
  font-weight: bold;
`;

export const ErrorMessage = styled.p`
  margin-bottom: 25px;
  font-weight: normal;
  text-align: center;
`;
